import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "../../../../../utils/axiosInceptor";
import { InputField, ReactSelectField } from "../../../../atoms/FormElement";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { maintenanceService } from "../../../../../configs/constants";
import { Row, Col, Button, Form, Typography, message, Space, Spin, Switch } from "antd";
import { Info } from "../../../../../assets/svg";
import { MINIMUM_ADVANCE } from "../../../BookingForm/components/utils";
import { SelectOption } from "../../../../../types/select";
import { getSelectPlaceholderMessage, getValidationProps } from "../../../../libs/form";

const priceUnitOptions: SelectOption[] = [
  { label: "Per Item", value: "per_item" },
  { label: "Per Piece", value: "per_piece" },
  { label: "Per Service", value: "per_service" },
];

const defaultValues: any = {
  name: "",
};

const configTimeSlot = [
  { value: 15, label: "15" },
  { value: 30, label: "30" },
  { value: 45, label: "45" },
  { value: 60, label: "60" },
  { value: 90, label: "90" },
  { value: 120, label: "120" },
  { value: 150, label: "150" },
  { value: 180, label: "180" },
];

const { Paragraph } = Typography;

const UpdateServices = (props) => {
  const { categoryRoot, onUpdate, parentKey, childKey, childDetail, setVisible, type, categoryType, addSubCat } = props;

  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [loader, setLoader] = useState(false);
  const [paidSubCate, setPiadCate] = useState(false);

  let categoryRootData = categoryRoot;
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = useForm({
    defaultValues,
  });

  const condition = type === "category";

  const updateTimeSlot = (newTimeSlot) => {
    if (parentKey != null && categoryRootData?.length > 0 && addSubCat === 1) {
      if (categoryRootData[parentKey]?.subCategories?.length > 0 && childKey != null) {
        categoryRootData[parentKey].subCategories[childKey].timeInMin = newTimeSlot?.timeInMin?.value
          ? newTimeSlot?.timeInMin?.value
          : categoryRootData[parentKey].subCategories[childKey].timeInMin;
        categoryRootData[parentKey].subCategories[childKey].paid = paidSubCate ? paidSubCate : false;
        categoryRootData[parentKey].subCategories[childKey].amount = paidSubCate ? newTimeSlot?.amount : 0;
        categoryRootData[parentKey].subCategories[childKey].vat = paidSubCate ? newTimeSlot?.vat : 0;
        categoryRootData[parentKey].subCategories[childKey].minimumAdvanceNotice = Number(
          newTimeSlot?.minimumAdvanceNotice
        );

        if (paidSubCate && newTimeSlot?.priceUnit?.label && newTimeSlot?.priceUnit?.value) {
          categoryRootData[parentKey].subCategories[childKey].priceUnit = newTimeSlot.priceUnit;
        }

        return categoryRootData;
      }
    } else if (addSubCat === 2) {
      categoryRootData[parentKey].subCategories.push({
        name: newTimeSlot?.name,
        timeInMin: newTimeSlot?.timeInMin?.value,
        paid: paidSubCate ? paidSubCate : false,
        amount: paidSubCate ? newTimeSlot?.amount : 0,
        vat: paidSubCate ? newTimeSlot?.vat : 0,
        minimumAdvanceNotice: Number(newTimeSlot?.minimumAdvanceNotice),
        ...(paidSubCate && newTimeSlot?.priceUnit?.label && newTimeSlot?.priceUnit?.value
          ? { priceUnit: newTimeSlot.priceUnit }
          : {}),
      });
      return categoryRootData;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (childDetail && addSubCat === 1) {
      setPiadCate(childDetail?.paid);
      setValue("name", childDetail?.title);
      setValue(
        "timeInMin",
        configTimeSlot.filter((item) => item.value === childDetail.timeInMin)
      );
      setValue("minimumAdvanceNotice", childDetail?.minimumAdvanceNotice);
      setValue("priceUnit", childDetail?.priceUnit);
    } else if (addSubCat === 2) {
      reset();
      setPiadCate(false);
    }
  }, [childDetail, childDetail?.paid, addSubCat]);

  const onFinish = async (values) => {
    setLoader(true);
    setSubmited(true);

    const finalData = await updateTimeSlot(values);
    const orgId = JSON.parse(window.localStorage.getItem("login-response"))?.orgId;

    if (finalData && orgId) {
      try {
        let url = `${maintenanceService}/serviceprovider/category/${orgId}`;

        let postData = {
          [categoryType === "RES"
            ? "residentialCategories"
            : categoryType === "COM"
              ? "commercialCategories"
              : "internalCategories"]: finalData,
        };
        await axios.patch(url, postData);
        setTimeout(() => {
          setLoader(false);
          setSubmited(false);

          addSubCat === 1 ? message.success("Updated successfully") : message.success("Added successfully");
          reset();
          onUpdate();
          setVisible(false);
        }, 800);
      } catch (e) {
        setLoader(false);
        setisError(true);
        const { response } = e;
        setErrorMessage(response?.data?.message);
      }
    } else {
      message.success("Update Failed. Organization-Id not present");
    }
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)} className="bf-main">
      {loader && !isError && (
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Space size={24} className="w-100 text-center" direction="vertical">
              <Spin size="large" className="ag-fontSize32" />
            </Space>
          </Col>
        </Row>
      )}
      {!submited ? (
        <>
          <Row>
            <Col span={24} style={{ marginBottom: 10 }}>
              <Switch
                onChange={(e) => setPiadCate(e)}
                checked={paidSubCate}
                checkedChildren="Paid"
                unCheckedChildren="Unpaid"
              />
            </Col>
          </Row>
          <Row gutter={12}>
            <Col span={8}>
              <InputField
                isRequired={true}
                fieldname="minimumAdvanceNotice"
                label="Minimum Advance Notice (hours)"
                control={control}
                rules={{ required: "Please enter minimum advance notice" }}
                iProps={{
                  placeholder: "Minimum Advance Notice",
                  type: "number",
                  step: 1,
                  min: 0,
                  max: 12,
                }}
                disabled={false}
                setValue={setValue}
                valueGot={addSubCat === 1 ? childDetail?.minimumAdvanceNotice : 0}
                initValue="0"
                validate={errors.minimumAdvanceNotice && "error"}
                validMessage={errors.minimumAdvanceNotice && errors.minimumAdvanceNotice.message}
                tooltip={{ title: MINIMUM_ADVANCE, icon: <Info width="14" height="14" style={{ marginRight: 4 }} /> }}
              />
            </Col>
            <Col span={8}>
              <InputField
                isRequired={true}
                fieldname="name"
                label={condition ? "Category" : "Sub-Category"}
                control={control}
                rules={{ required: condition ? "Please enter category title" : "Please enter Sub-Category title" }}
                iProps={{ placeholder: condition ? "Plumbing" : "Water Leakage" }}
                disabled={addSubCat === 2 && !condition ? false : true}
                setValue={setValue}
                validate={errors.name && "error"}
                validMessage={errors.name && errors.name.message}
              />
            </Col>

            {!condition && (
              <Col span={8}>
                <ReactSelectField
                  control={control}
                  isRequired={true}
                  fieldname="timeInMin"
                  selectOption={configTimeSlot}
                  label="Time (minutes)"
                  validate={errors.timeInMin && "error"}
                  iProps={{ placeholder: "Choose time slot" }}
                  rules={{ required: "Please select the time slot" }}
                  validMessage={errors.timeInMin && errors.timeInMin.message}
                />
              </Col>
            )}
          </Row>
          {!condition && paidSubCate && (
            <Row gutter={12}>
              <Col span={8}>
                <InputField
                  isRequired={paidSubCate}
                  fieldname="amount"
                  label="Amount"
                  control={control}
                  rules={{ required: "Please enter amount" }}
                  iProps={{ placeholder: "Amount", type: "number" }}
                  disabled={false}
                  setValue={setValue}
                  valueGot={childDetail?.paid && addSubCat === 1 ? childDetail?.amount : 0}
                  initValue="0"
                  validate={errors.amount && "error"}
                  validMessage={errors.amount && errors.amount.message}
                />
              </Col>

              <Col span={8}>
                <InputField
                  isRequired={paidSubCate}
                  fieldname="vat"
                  label="Vat"
                  control={control}
                  rules={{ required: "Please enter vat" }}
                  iProps={{ placeholder: "Vat", type: "number" }}
                  disabled={false}
                  setValue={setValue}
                  valueGot={childDetail?.paid && addSubCat === 1 ? childDetail?.vat : 0}
                  initValue="0"
                  validate={errors.vat && "error"}
                  validMessage={errors.vat && errors.vat.message}
                />
              </Col>

              <Col span={8}>
                <ReactSelectField
                  fieldname="priceUnit"
                  label="Unit of price"
                  selectOption={priceUnitOptions}
                  control={control}
                  {...getValidationProps({ fieldName: "priceUnit", errors, isRequired: true })}
                  iProps={{ placeholder: getSelectPlaceholderMessage("priceUnit") }}
                />
              </Col>
            </Row>
          )}
          <Row gutter={24} justify="space-between">
            <Col>
              <Button className="ag-error theme_grey_btn" htmlType="button" onClick={() => setVisible(false)}>
                Back
              </Button>
            </Col>
            <Col>
              <Button className="ag-green-button theme_btn" htmlType="submit">
                {addSubCat === 1 ? " Update" : " Add"}
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        isError && (
          <>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Space size={24} className="w-100 text-center" direction="vertical">
                  <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                  <Paragraph className="ag-error fontWeight600 mb-0 sentanceCase">{errorMessage}</Paragraph>
                </Space>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Button
                  className="ag-gray-button-outline"
                  htmlType="button"
                  onClick={() => {
                    setPiadCate(false);
                    setSubmited(false);
                    setisError(false);
                  }}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </>
        )
      )}
    </Form>
  );
};

export default UpdateServices;
